"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _AccordionPanel = _interopRequireDefault(require("./AccordionPanel"));
var _clsx = _interopRequireDefault(require("clsx"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      width: '100%'
    },
    padding: {
      padding: '0'
    }
  };
});
function stripPathFromKey(key) {
  var strippedKey = key.split('/');
  return strippedKey[strippedKey.length - 1];
}
var AccordionComponent = function AccordionComponent(_ref) {
  var children = _ref.children,
    headingElement = _ref.headingElement,
    expandedItems = _ref.expandedItems,
    singleExpansion = _ref.singleExpansion,
    faqContent = _ref.faqContent;
  var classes = useStyles();
  var _React$useState = _react.default.useState(function () {
      var childKeys = children.map(function (content) {
        return stripPathFromKey(content.key);
      });
      return singleExpansion && childKeys.length > 0 ? childKeys.indexOf(expandedItems[0]) : false;
    }),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    expanded = _React$useState2[0],
    setExpanded = _React$useState2[1];
  var handleChange = function handleChange(panel) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panel : false);
    };
  };
  return __jsx("div", {
    className: (0, _clsx.default)(classes.wrapper, children.length > 0 && classes.padding)
  }, children.map(function (content, panelIndex) {
    var expandedByDefault = expandedItems.indexOf(stripPathFromKey(content.key)) > -1;
    var expandedProps = {
      defaultExpanded: expandedByDefault
    };
    if (singleExpansion) {
      expandedProps.expanded = expandedProps.disabled = expanded === panelIndex;
      expandedProps.onChange = handleChange(panelIndex);
    }
    return __jsx(_AccordionPanel.default, {
      key: panelIndex,
      expandedProps: expandedProps,
      content: content,
      headingElement: headingElement,
      faqContent: faqContent
    });
  }));
};
var _default = AccordionComponent;
exports.default = _default;